import { createRootRoute, Outlet } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/router-devtools"
import { shape, string } from "prop-types"
import AnalyticsTracker from "@/components/AnalyticsTracker"
import AuthGate from "@/components/AuthGate"
import QueryErrorBoundary from "@/components/QueryErrorBoundary"
import RouteErrorBoundary from "@/components/RouteErrorBoundary"
import ErrorPage from "@/components/ErrorPage"
import NotFoundPage from "@/components/NotFoundPage"
import SnackbarProvider from "@/components/SnackbarProvider"
import { useLocationKey } from "@/hooks/useLocationKey"

function RootComponent() {
  const locationKey = useLocationKey()
  return (
    <>
      <SnackbarProvider>
        <RouteErrorBoundary locationKey={locationKey}>
          <QueryErrorBoundary>
            <AuthGate>
              <AnalyticsTracker />
              <Outlet />
            </AuthGate>
          </QueryErrorBoundary>
        </RouteErrorBoundary>
      </SnackbarProvider>
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}

const normalizeErrorMessage = (error) => {
  if (error == null) return undefined
  if (typeof error === "string") return error
  if (typeof error.message === "string") return error.message
  try {
    return JSON.stringify(error)
  } catch {
    return String(error)
  }
}

function RouteErrorFallback({ error }) {
  return <ErrorPage message={normalizeErrorMessage(error)} />
}

RouteErrorFallback.propTypes = {
  error: shape({ message: string })
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RouteErrorFallback,
  notFoundComponent: NotFoundPage
})
